import React from 'react';

const SubmitButton = (props) => (
  <button type="submit" className="btn btn-block btn-info" {...props}>
    {props.children}
  </button>
)

export default SubmitButton;
